import {FC} from 'react'

type Props = {
  phoneNumber?: string
}

const CIQPhoneNumberCell: FC<Props> = ({phoneNumber}) => (
  <div className='text-gray-650 mb-1'>{phoneNumber}</div> //text-hover-primary
)

export {CIQPhoneNumberCell}
